import React from 'react';
import styles from "./AdVoucher.module.scss";
import numeral from 'numeral';
import {IProduct} from 'data/interfaces/products';
import VoucherImageSquare from 'gui/components/listPage/components/ad/components/voucherImageSquare/VoucherImageSquare';
import {currencyValueToTextLabel} from 'gui/components/formikCurrencySelector';
import AdCardStructureContainer from 'data/redux/containers/adCardStructureContainer';
import {getVoucherName, voucherTypeText} from 'data/redux/selectors/productSelector';
import AdLeaveDate from 'gui/components/listPage/components/ad/components/adLeaveDate';
import {eSavingsType} from 'gui/components/listPage/components/ad/components/adPurchase/components/adSavings';

interface IAdProps {
  product: IProduct;

  view?: (id: number) => void
  edit?: (id: number) => void
  delete?: (id: number) => void
}


export const generateVoucherTitle = props => [voucherTypeText(props.product), getVoucherName(props.product), "-", 'בשווי', numeral(props.product.voucherDetails.voucherBalance).format("0,0"), currencyValueToTextLabel[props.product.voucherDetails.currency]].filter(s => s).join(' ');

const AdVoucher = (props: IAdProps) => {
  return (
    <AdCardStructureContainer
      cardTitle={generateVoucherTitle(props)}
      specialDetails={
        <AdLeaveDate
          label="תאריך סיום תוקף"
          endDate={props.product.voucherDetails.expiration}
        />
      }
      displaySquare={VoucherImageSquare}
      timeRemaining={props.product.voucherDetails.expiration}
      salePriceLabel="מחיר מכירה"
      originalPriceLabel="ערך השובר"
      originalPrice={props.product.voucherDetails.voucherBalance}
      originalPriceClassName={styles.originalPrice}
      savingsType={eSavingsType.PERCENTAGE}
      {...props}
    />

  )
};

AdVoucher.defaultProps = {
  product: {},

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
};
export default AdVoucher;
